import { render, staticRenderFns } from "./TopUpSuccess.vue?vue&type=template&id=6bb8ffdd&scoped=true&"
import script from "./TopUpSuccess.vue?vue&type=script&lang=js&"
export * from "./TopUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TopUpSuccess.vue?vue&type=style&index=0&id=6bb8ffdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8ffdd",
  null
  
)

export default component.exports